//#region IMPORT
import React from 'react';
/** Components Import */
import { Box, Stack, Typography } from '@mui/material';
import ReactPlayer from 'react-player/lazy';
/** Icons Import */
//#endregion

function M_TRA_BASIC_02(props) {
  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          교육 자료
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          교육 동영상을 확인해주세요.
        </Typography>
      </Stack>
      {!props.inputs.video ? (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="60vh"
        >
          <Typography variant="h5" fontWeight={550}>
            등록된 동영상이 없습니다.
          </Typography>
          <Typography variant="body1">관리자에게 문의하세요.</Typography>
        </Box>
      ) : (
        <Box sx={{ bgcolor: '#000000' }}>
          <ReactPlayer
            ref={props.videoRef}
            url={props.inputs.video}
            width="100%"
            height="40vh"
            controls={true}
            onEnded={props.HandleVideoEnd}
            onProgress={props.HandleProgress}
            onSeek={props.HandleSeek}
            onError={(e) => props.HandleVideoError(e)}
            progressInterval={100}
            playing={props.play}
            config={{
              file: {
                attributes: {
                  controlsList: 'nodownload',
                  preload: 'metadata',
                },
              },
            }}
          />
        </Box>
      )}
    </>
  );
}

export default M_TRA_BASIC_02;
